import {
  createCachedRequester
} from "./chunk-52EWCQEE.js";
import {
  as_calendar_default
} from "./chunk-TNJADJJC.js";
import {
  as_list_default
} from "./chunk-NVQ7FPJ7.js";
import {
  __commonJS,
  __toESM
} from "./chunk-JSBRDJBE.js";

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseRepeat.js
var require_baseRepeat = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseRepeat.js"(exports, module) {
    "use strict";
    var MAX_SAFE_INTEGER = 9007199254740991;
    var nativeFloor = Math.floor;
    function baseRepeat(string, n) {
      var result = "";
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);
      return result;
    }
    module.exports = baseRepeat;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_freeGlobal.js
var require_freeGlobal = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_freeGlobal.js"(exports, module) {
    "use strict";
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    module.exports = freeGlobal;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_root.js
var require_root = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_root.js"(exports, module) {
    "use strict";
    var freeGlobal = require_freeGlobal();
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    module.exports = root;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Symbol.js
var require_Symbol = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Symbol.js"(exports, module) {
    "use strict";
    var root = require_root();
    var Symbol = root.Symbol;
    module.exports = Symbol;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayMap.js
var require_arrayMap = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayMap.js"(exports, module) {
    "use strict";
    function arrayMap(array, iteratee) {
      var index = -1, length = array == null ? 0 : array.length, result = Array(length);
      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }
    module.exports = arrayMap;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArray.js
var require_isArray = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArray.js"(exports, module) {
    "use strict";
    var isArray = Array.isArray;
    module.exports = isArray;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getRawTag.js
var require_getRawTag = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getRawTag.js"(exports, module) {
    "use strict";
    var Symbol = require_Symbol();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var nativeObjectToString = objectProto.toString;
    var symToStringTag = Symbol ? Symbol.toStringTag : void 0;
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e) {
      }
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    module.exports = getRawTag;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_objectToString.js
var require_objectToString = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_objectToString.js"(exports, module) {
    "use strict";
    var objectProto = Object.prototype;
    var nativeObjectToString = objectProto.toString;
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    module.exports = objectToString;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetTag.js
var require_baseGetTag = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetTag.js"(exports, module) {
    "use strict";
    var Symbol = require_Symbol();
    var getRawTag = require_getRawTag();
    var objectToString = require_objectToString();
    var nullTag = "[object Null]";
    var undefinedTag = "[object Undefined]";
    var symToStringTag = Symbol ? Symbol.toStringTag : void 0;
    function baseGetTag(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    module.exports = baseGetTag;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObjectLike.js
var require_isObjectLike = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObjectLike.js"(exports, module) {
    "use strict";
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    module.exports = isObjectLike;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isSymbol.js
var require_isSymbol = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isSymbol.js"(exports, module) {
    "use strict";
    var baseGetTag = require_baseGetTag();
    var isObjectLike = require_isObjectLike();
    var symbolTag = "[object Symbol]";
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
    }
    module.exports = isSymbol;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseToString.js
var require_baseToString = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseToString.js"(exports, module) {
    "use strict";
    var Symbol = require_Symbol();
    var arrayMap = require_arrayMap();
    var isArray = require_isArray();
    var isSymbol = require_isSymbol();
    var INFINITY = 1 / 0;
    var symbolProto = Symbol ? Symbol.prototype : void 0;
    var symbolToString = symbolProto ? symbolProto.toString : void 0;
    function baseToString(value) {
      if (typeof value == "string") {
        return value;
      }
      if (isArray(value)) {
        return arrayMap(value, baseToString) + "";
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : "";
      }
      var result = value + "";
      return result == "0" && 1 / value == -INFINITY ? "-0" : result;
    }
    module.exports = baseToString;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSlice.js
var require_baseSlice = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSlice.js"(exports, module) {
    "use strict";
    function baseSlice(array, start, end) {
      var index = -1, length = array.length;
      if (start < 0) {
        start = -start > length ? 0 : length + start;
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : end - start >>> 0;
      start >>>= 0;
      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }
    module.exports = baseSlice;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_castSlice.js
var require_castSlice = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_castSlice.js"(exports, module) {
    "use strict";
    var baseSlice = require_baseSlice();
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === void 0 ? length : end;
      return !start && end >= length ? array : baseSlice(array, start, end);
    }
    module.exports = castSlice;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hasUnicode.js
var require_hasUnicode = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hasUnicode.js"(exports, module) {
    "use strict";
    var rsAstralRange = "\\ud800-\\udfff";
    var rsComboMarksRange = "\\u0300-\\u036f";
    var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
    var rsComboSymbolsRange = "\\u20d0-\\u20ff";
    var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
    var rsVarRange = "\\ufe0e\\ufe0f";
    var rsZWJ = "\\u200d";
    var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    function hasUnicode(string) {
      return reHasUnicode.test(string);
    }
    module.exports = hasUnicode;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseProperty.js
var require_baseProperty = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseProperty.js"(exports, module) {
    "use strict";
    function baseProperty(key) {
      return function(object) {
        return object == null ? void 0 : object[key];
      };
    }
    module.exports = baseProperty;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_asciiSize.js
var require_asciiSize = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_asciiSize.js"(exports, module) {
    "use strict";
    var baseProperty = require_baseProperty();
    var asciiSize = baseProperty("length");
    module.exports = asciiSize;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_unicodeSize.js
var require_unicodeSize = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_unicodeSize.js"(exports, module) {
    "use strict";
    var rsAstralRange = "\\ud800-\\udfff";
    var rsComboMarksRange = "\\u0300-\\u036f";
    var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
    var rsComboSymbolsRange = "\\u20d0-\\u20ff";
    var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
    var rsVarRange = "\\ufe0e\\ufe0f";
    var rsAstral = "[" + rsAstralRange + "]";
    var rsCombo = "[" + rsComboRange + "]";
    var rsFitz = "\\ud83c[\\udffb-\\udfff]";
    var rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")";
    var rsNonAstral = "[^" + rsAstralRange + "]";
    var rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}";
    var rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]";
    var rsZWJ = "\\u200d";
    var reOptMod = rsModifier + "?";
    var rsOptVar = "[" + rsVarRange + "]?";
    var rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*";
    var rsSeq = rsOptVar + reOptMod + rsOptJoin;
    var rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
    var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    function unicodeSize(string) {
      var result = reUnicode.lastIndex = 0;
      while (reUnicode.test(string)) {
        ++result;
      }
      return result;
    }
    module.exports = unicodeSize;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stringSize.js
var require_stringSize = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stringSize.js"(exports, module) {
    "use strict";
    var asciiSize = require_asciiSize();
    var hasUnicode = require_hasUnicode();
    var unicodeSize = require_unicodeSize();
    function stringSize(string) {
      return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    module.exports = stringSize;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_asciiToArray.js
var require_asciiToArray = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_asciiToArray.js"(exports, module) {
    "use strict";
    function asciiToArray(string) {
      return string.split("");
    }
    module.exports = asciiToArray;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_unicodeToArray.js
var require_unicodeToArray = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_unicodeToArray.js"(exports, module) {
    "use strict";
    var rsAstralRange = "\\ud800-\\udfff";
    var rsComboMarksRange = "\\u0300-\\u036f";
    var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
    var rsComboSymbolsRange = "\\u20d0-\\u20ff";
    var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
    var rsVarRange = "\\ufe0e\\ufe0f";
    var rsAstral = "[" + rsAstralRange + "]";
    var rsCombo = "[" + rsComboRange + "]";
    var rsFitz = "\\ud83c[\\udffb-\\udfff]";
    var rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")";
    var rsNonAstral = "[^" + rsAstralRange + "]";
    var rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}";
    var rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]";
    var rsZWJ = "\\u200d";
    var reOptMod = rsModifier + "?";
    var rsOptVar = "[" + rsVarRange + "]?";
    var rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*";
    var rsSeq = rsOptVar + reOptMod + rsOptJoin;
    var rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
    var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    function unicodeToArray(string) {
      return string.match(reUnicode) || [];
    }
    module.exports = unicodeToArray;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stringToArray.js
var require_stringToArray = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stringToArray.js"(exports, module) {
    "use strict";
    var asciiToArray = require_asciiToArray();
    var hasUnicode = require_hasUnicode();
    var unicodeToArray = require_unicodeToArray();
    function stringToArray(string) {
      return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    module.exports = stringToArray;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createPadding.js
var require_createPadding = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createPadding.js"(exports, module) {
    "use strict";
    var baseRepeat = require_baseRepeat();
    var baseToString = require_baseToString();
    var castSlice = require_castSlice();
    var hasUnicode = require_hasUnicode();
    var stringSize = require_stringSize();
    var stringToArray = require_stringToArray();
    var nativeCeil = Math.ceil;
    function createPadding(length, chars) {
      chars = chars === void 0 ? " " : baseToString(chars);
      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
    }
    module.exports = createPadding;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_trimmedEndIndex.js
var require_trimmedEndIndex = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_trimmedEndIndex.js"(exports, module) {
    "use strict";
    var reWhitespace = /\s/;
    function trimmedEndIndex(string) {
      var index = string.length;
      while (index-- && reWhitespace.test(string.charAt(index))) {
      }
      return index;
    }
    module.exports = trimmedEndIndex;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseTrim.js
var require_baseTrim = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseTrim.js"(exports, module) {
    "use strict";
    var trimmedEndIndex = require_trimmedEndIndex();
    var reTrimStart = /^\s+/;
    function baseTrim(string) {
      return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    module.exports = baseTrim;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObject.js
var require_isObject = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObject.js"(exports, module) {
    "use strict";
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    module.exports = isObject;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toNumber.js
var require_toNumber = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toNumber.js"(exports, module) {
    "use strict";
    var baseTrim = require_baseTrim();
    var isObject = require_isObject();
    var isSymbol = require_isSymbol();
    var NAN = 0 / 0;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsOctal = /^0o[0-7]+$/i;
    var freeParseInt = parseInt;
    function toNumber(value) {
      if (typeof value == "number") {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
      }
      if (typeof value != "string") {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    module.exports = toNumber;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toFinite.js
var require_toFinite = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toFinite.js"(exports, module) {
    "use strict";
    var toNumber = require_toNumber();
    var INFINITY = 1 / 0;
    var MAX_INTEGER = 17976931348623157e292;
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }
    module.exports = toFinite;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toInteger.js
var require_toInteger = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toInteger.js"(exports, module) {
    "use strict";
    var toFinite = require_toFinite();
    function toInteger(value) {
      var result = toFinite(value), remainder = result % 1;
      return result === result ? remainder ? result - remainder : result : 0;
    }
    module.exports = toInteger;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toString.js
var require_toString = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toString.js"(exports, module) {
    "use strict";
    var baseToString = require_baseToString();
    function toString(value) {
      return value == null ? "" : baseToString(value);
    }
    module.exports = toString;
  }
});

// ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/padStart.js
var require_padStart = __commonJS({
  "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/padStart.js"(exports, module) {
    "use strict";
    var createPadding = require_createPadding();
    var stringSize = require_stringSize();
    var toInteger = require_toInteger();
    var toString = require_toString();
    function padStart2(string, length, chars) {
      string = toString(string);
      length = toInteger(length);
      var strLength = length ? stringSize(string) : 0;
      return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
    }
    module.exports = padStart2;
  }
});

// src/layouts/calendar/calendar.tsx
var import_padStart = __toESM(require_padStart(), 1);
import { trackEvent } from "@a24/analytics";
import Select from "@a24/form/Select";
import Button from "@a24/ui/Button";
import Divider from "@a24/ui/Divider";
import Title from "@a24/ui/Title";
import { useGSAP } from "@gsap/react";
import { liteClient as algoliasearch } from "algoliasearch/lite";
import gsap from "gsap";
import { useCallback, useEffect, useState } from "react";
import {
  Configure,
  InstantSearch,
  useClearRefinements,
  useHits,
  useRefinementList
} from "react-instantsearch";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
gsap.registerPlugin(useGSAP);
var searchClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_ID || "",
  process.env.NEXT_PUBLIC_ALGOLIA_KEY || "",
  {
    requester: createCachedRequester("calendar")
  }
);
var indexName = process.env.NEXT_PUBLIC_ALGOLIA_PERFORMANCES_INDEX;
var RefinementSelect = ({
  attribute,
  className,
  includeAllOption = false,
  label = "No label",
  limit,
  sortBy,
  onChangeOverride
}) => {
  const clearRefinementsApi = useClearRefinements({
    includedAttributes: [attribute]
  });
  const { items, refine } = useRefinementList({
    attribute,
    limit,
    sortBy
  });
  const onChange = (value) => {
    if (onChangeOverride) {
      onChangeOverride(value);
      return;
    }
    const option = items.find((item) => item.value === value);
    if (option) {
      clearRefinementsApi.refine();
      refine(option.value);
    } else {
      clearRefinementsApi.refine();
    }
  };
  if (items.length === 0) {
    return /* @__PURE__ */ jsx(Fragment, {});
  }
  return /* @__PURE__ */ jsx(
    Select,
    {
      className,
      includeAllOption,
      label,
      name: "select",
      onChange,
      options: items,
      placeholder: "All",
      selectedOption: items.filter((item) => item.isRefined).pop()?.value
    }
  );
};
var CalendarBody = ({
  labels = {
    displayAsCalendar: "Calendar",
    displayAsList: "List",
    filterShowType: "Show Type",
    filterMonth: "Month",
    filterYear: "Year",
    loadMore: "Load more dates",
    lowAvailability: "Low Availability",
    nextMonth: "Next month",
    previousMonth: "Previous month",
    soldOut: "Sold Out",
    unavailable: "Sold Out"
  }
}) => {
  const [view, setView] = useState(labels.displayAsList);
  const [isPrevButtonDisabled, setIsPrevButtonDisabled] = useState(false);
  const [isNextButtonDisabled, setIsNextButtonDisabled] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isInitialized, setIsInitialized] = useState(false);
  const [currentMonth, setCurrentMonth] = useState(null);
  const [currentYear, setCurrentYear] = useState(null);
  const [allAvailableYearMonths, setAllAvailableYearMonths] = useState([]);
  const clearRefinementsApi = useClearRefinements({
    includedAttributes: ["month", "year"]
  });
  const clearMonthRefinementsApi = useClearRefinements({
    includedAttributes: ["month"]
  });
  const clearYearRefinementsApi = useClearRefinements({
    includedAttributes: ["year"]
  });
  const monthList = useRefinementList({
    attribute: "month",
    limit: 100,
    sortBy: ["name:asc"]
  });
  const yearList = useRefinementList({
    attribute: "year",
    limit: 100,
    sortBy: ["name:asc"]
  });
  const { results } = useHits();
  useEffect(() => {
    if (allAvailableYearMonths.length === 0 && results?.hits && results.hits.length > 0) {
      const combinations = /* @__PURE__ */ new Set();
      const now = /* @__PURE__ */ new Date();
      const currentYearMonth = `${now.getFullYear()}-${(0, import_padStart.default)(String(now.getMonth() + 1), 2, "0")}`;
      for (const hit of results.hits) {
        const hitData = hit;
        if (hitData.year && hitData.month) {
          const yearMonth = `${hitData.year}-${hitData.month}`;
          if (yearMonth >= currentYearMonth) {
            combinations.add(yearMonth);
          }
        }
      }
      const sortedCombinations = Array.from(combinations).map((combo) => {
        const [year, month] = combo.split("-");
        return { year: year || "", month: month || "" };
      }).filter((combo) => combo.year && combo.month).sort((a, b) => {
        if (a.year !== b.year) {
          return Number.parseInt(a.year) - Number.parseInt(b.year);
        }
        return Number.parseInt(a.month) - Number.parseInt(b.month);
      });
      setAllAvailableYearMonths(sortedCombinations);
    }
  }, [results, allAvailableYearMonths.length]);
  const getAvailableYearMonths = useCallback(() => {
    return allAvailableYearMonths;
  }, [allAvailableYearMonths]);
  const getCurrentPosition = useCallback(() => {
    if (!currentYear || !currentMonth) return -1;
    const combinations = getAvailableYearMonths();
    return combinations.findIndex(
      (combo) => combo.year === currentYear && combo.month === currentMonth
    );
  }, [currentYear, currentMonth, getAvailableYearMonths]);
  const updateButtonStates = useCallback(() => {
    const combinations = getAvailableYearMonths();
    const currentPos = getCurrentPosition();
    if (currentPos === -1 || combinations.length === 0) {
      setIsPrevButtonDisabled(true);
      setIsNextButtonDisabled(true);
      return;
    }
    setIsPrevButtonDisabled(currentPos === 0);
    setIsNextButtonDisabled(currentPos === combinations.length - 1);
  }, [getAvailableYearMonths, getCurrentPosition]);
  useEffect(() => {
    if (isInitialized || yearList.items.length === 0 || monthList.items.length === 0 || allAvailableYearMonths.length === 0) {
      return;
    }
    const now = /* @__PURE__ */ new Date();
    const currentYearValue = now.getFullYear().toString();
    const currentMonthValue = (0, import_padStart.default)((now.getMonth() + 1).toString(), 2, "0");
    const currentCombo = allAvailableYearMonths.find(
      (combo) => combo.year === currentYearValue && combo.month === currentMonthValue
    );
    const comboToSelect = currentCombo || allAvailableYearMonths[0];
    if (!comboToSelect) return;
    yearList.refine(comboToSelect.year);
    setCurrentYear(comboToSelect.year);
    monthList.refine(comboToSelect.month);
    setCurrentMonth(comboToSelect.month);
    setIsInitialized(true);
  }, [
    yearList.items,
    monthList.items,
    isInitialized,
    yearList,
    monthList,
    allAvailableYearMonths
  ]);
  useEffect(() => {
    if (!isInitialized) return;
    const refinedYear = yearList.items.find((item) => item.isRefined);
    const refinedMonth = monthList.items.find((item) => item.isRefined);
    if (refinedYear && refinedYear.value !== currentYear) {
      setCurrentYear(refinedYear.value);
    }
    if (refinedMonth && refinedMonth.value !== currentMonth) {
      setCurrentMonth(refinedMonth.value);
    }
  }, [
    yearList.items,
    monthList.items,
    isInitialized,
    currentYear,
    currentMonth
  ]);
  useEffect(() => {
    if (currentYear && currentMonth) {
      updateButtonStates();
      const currentPos = getCurrentPosition();
      const combinations = getAvailableYearMonths();
      setIsButtonDisabled(
        currentPos === combinations.length - 1 || combinations.length === 0
      );
    }
  }, [
    currentYear,
    currentMonth,
    updateButtonStates,
    getCurrentPosition,
    getAvailableYearMonths
  ]);
  const toggleCalendar = (isOn) => {
    if (isOn) {
      goToCalendar();
    } else {
      goToList();
    }
    setView(isOn ? labels.displayAsCalendar : labels.displayAsList);
  };
  const goToCalendar = () => {
    setView(labels.displayAsCalendar);
  };
  const goToList = () => {
    setView(labels.displayAsList);
  };
  const selectPreviousMonth = () => {
    const combinations = getAvailableYearMonths();
    const currentPos = getCurrentPosition();
    if (currentPos <= 0) return;
    const prevCombo = combinations[currentPos - 1];
    if (!prevCombo) return;
    clearYearRefinementsApi.refine();
    clearMonthRefinementsApi.refine();
    yearList.refine(prevCombo.year);
    monthList.refine(prevCombo.month);
    setCurrentYear(prevCombo.year);
    setCurrentMonth(prevCombo.month);
    trackEvent({
      name: "button_interaction",
      data: { value: "Calendar|Previous Month" }
    });
  };
  const selectNextMonth = () => {
    const combinations = getAvailableYearMonths();
    const currentPos = getCurrentPosition();
    if (currentPos === -1 || currentPos >= combinations.length - 1) return;
    const nextCombo = combinations[currentPos + 1];
    if (!nextCombo) return;
    clearYearRefinementsApi.refine();
    clearMonthRefinementsApi.refine();
    yearList.refine(nextCombo.year);
    monthList.refine(nextCombo.month);
    setCurrentYear(nextCombo.year);
    setCurrentMonth(nextCombo.month);
    trackEvent({
      name: "button_interaction",
      data: { value: "Calendar|Next Month" }
    });
  };
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add(
      {
        isDesktop: "(min-width: 1024px)",
        isMobile: "(max-width: 1023px)"
      },
      (context) => {
        const { isDesktop } = context.conditions;
        toggleCalendar(isDesktop || false);
      }
    );
  });
  const handleCalendarClick = () => {
    goToCalendar();
    trackEvent({
      name: "button_interaction",
      data: { value: "Shows|Calendar View" }
    });
  };
  const handleListClick = () => {
    goToList();
    trackEvent({
      name: "button_interaction",
      data: { value: "Shows|List View" }
    });
  };
  const handleMoreClick = () => {
    trackEvent({ name: "button_interaction", data: { value: "Shows|More" } });
    const combinations = getAvailableYearMonths();
    const currentPos = getCurrentPosition();
    if (currentPos === -1 || currentPos >= combinations.length - 1) return;
    const nextCombo = combinations[currentPos + 1];
    if (!nextCombo) return;
    clearYearRefinementsApi.refine();
    clearMonthRefinementsApi.refine();
    yearList.refine(nextCombo.year);
    monthList.refine(nextCombo.month);
    setCurrentYear(nextCombo.year);
    setCurrentMonth(nextCombo.month);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const handleYearChange = useCallback(
    (value) => {
      if (!value) return;
      clearYearRefinementsApi.refine();
      yearList.refine(value);
      setCurrentYear(value);
      const monthsForYear = allAvailableYearMonths.filter((combo) => combo.year === value).map((combo) => combo.month).sort((a, b) => Number.parseInt(a) - Number.parseInt(b));
      if (monthsForYear.length > 0 && monthsForYear[0]) {
        clearMonthRefinementsApi.refine();
        monthList.refine(monthsForYear[0]);
        setCurrentMonth(monthsForYear[0]);
      }
    },
    [
      clearYearRefinementsApi,
      yearList,
      monthList,
      clearMonthRefinementsApi,
      allAvailableYearMonths
    ]
  );
  const handleMonthChange = useCallback(
    (value) => {
      if (!value) return;
      clearMonthRefinementsApi.refine();
      monthList.refine(value);
      setCurrentMonth(value);
    },
    [clearMonthRefinementsApi, monthList]
  );
  const availableYears = Array.from(
    new Set(allAvailableYearMonths.map((combo) => combo.year))
  ).sort();
  const availableMonthsForYear = currentYear ? allAvailableYearMonths.filter((combo) => combo.year === currentYear).map((combo) => combo.month).sort((a, b) => Number.parseInt(a) - Number.parseInt(b)) : Array.from(
    new Set(allAvailableYearMonths.map((combo) => combo.month))
  ).sort((a, b) => Number.parseInt(a) - Number.parseInt(b));
  const monthOptions = availableMonthsForYear.length > 0 ? availableMonthsForYear.map((value) => ({
    value,
    label: new Date(2e3, Number.parseInt(value) - 1, 1).toLocaleString(
      "en",
      { month: "long" }
    ),
    count: 0,
    isRefined: value === currentMonth
  })) : monthList.items;
  const yearOptions = availableYears.length > 0 ? availableYears.map((value) => ({
    value,
    label: value,
    count: 0,
    isRefined: value === currentYear
  })) : yearList.items;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: "col-span-full row-span-1 flex justify-between", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex md:items-end justify-between flex-col md:flex-row w-full md:w-auto", children: [
        /* @__PURE__ */ jsx(
          RefinementSelect,
          {
            className: "label-filter !w-full md:!w-[11rem] mb-6 min-w-80 md:mb-0 md:md-0 md:mr-4",
            attribute: "category",
            includeAllOption: true,
            label: "Show Type",
            limit: 100,
            sortBy: ["name:asc"]
          }
        ),
        /* @__PURE__ */ jsx(
          Select,
          {
            className: "label-filter !w-full md:!w-[11rem] mb-6 min-w-40 md:mb-0 md:md-0 md:mr-4",
            label: "Month",
            name: "month-select",
            onChange: handleMonthChange,
            options: monthOptions,
            selectedOption: currentMonth || void 0
          }
        ),
        /* @__PURE__ */ jsx(
          Select,
          {
            className: "label-filter !w-full md:!w-[11rem] mb-6 min-w-40 md:mb-0 md:md-0",
            label: "Year",
            name: "year-select",
            onChange: handleYearChange,
            options: yearOptions,
            selectedOption: currentYear || void 0
          }
        )
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "hidden lg:block self-end -mr-4", children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            label: labels.displayAsList,
            onClick: handleListClick,
            className: `button ${view === labels.displayAsList ? "text-heritage-red-full" : ""}`
          }
        ),
        /* @__PURE__ */ jsxs("span", { children: [
          /* @__PURE__ */ jsx("span", { className: "text-heritage-off-white-60", children: "|" }),
          /* @__PURE__ */ jsx(
            Button,
            {
              label: labels.displayAsCalendar,
              onClick: handleCalendarClick,
              className: `button  ${view === labels.displayAsCalendar ? "text-heritage-red-full" : ""}`
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "col-span-full row-span-1", children: /* @__PURE__ */ jsx(Divider, { className: "col-span-full pt-4 pb-10 md:pt-6 md:pb-6" }) }),
    /* @__PURE__ */ jsxs("div", { className: "col-span-full", children: [
      view === labels.displayAsCalendar && currentYear && currentMonth && /* @__PURE__ */ jsx(
        as_calendar_default,
        {
          labels,
          monthYearToDisplay: new Date(
            Number.parseInt(currentYear),
            Number.parseInt(currentMonth) - 1,
            1
          ),
          isPrevButtonDisabled,
          isNextButtonDisabled,
          selectPreviousMonth,
          selectNextMonth
        }
      ),
      view === labels.displayAsList && /* @__PURE__ */ jsx(
        as_list_default,
        {
          labels,
          handleMoreClick,
          isButtonDisabled
        }
      )
    ] })
  ] });
};
var Calendar = ({
  className,
  id,
  labels = {
    displayAsCalendar: "Calendar",
    displayAsList: "List",
    filterShowType: "Show Type",
    filterMonth: "Month",
    filterYear: "Year",
    loadMore: "Load more dates",
    lowAvailability: "Low Availability",
    nextMonth: "Next month",
    previousMonth: "Previous month",
    soldOut: "Sold Out"
  },
  title
}) => {
  return /* @__PURE__ */ jsxs(
    InstantSearch,
    {
      searchClient,
      indexName,
      future: {
        preserveSharedStateOnUnmount: true
      },
      initialUiState: {
        All_Performances: {
          refinementList: {
            //month: [format(new Date(), 'MM')],
            //year: [format(new Date(), 'yyyy')]
          }
        },
        Development_All_Performances: {
          refinementList: {
            //month: [format(new Date(), 'MM')],
            //year: [format(new Date(), 'yyyy')]
          }
        }
      },
      children: [
        /* @__PURE__ */ jsx(Configure, { hitsPerPage: 1e3 }),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: `grid grid-cols-12 gap-x-3 ${className} max-md:px-6 max-2xl:px-16`,
            id,
            children: [
              /* @__PURE__ */ jsx("div", { className: "col-span-full row-span-1", children: title && /* @__PURE__ */ jsx(
                Title,
                {
                  className: "heading-xl pb-10 md:pb-14",
                  level: "h1",
                  text: title
                }
              ) }),
              /* @__PURE__ */ jsx(CalendarBody, { labels })
            ]
          }
        )
      ]
    }
  );
};
var calendar_default = Calendar;

export {
  calendar_default
};
